import { motion } from "framer-motion";
import React from "react";
import { pageTransition, pageVariants } from "../hooks/pagetransition";

const Collaboration = () => {
  return (
    <motion.div
      className="text-center m-auto pb-3"
      style={{ width: "60%" }}
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <div>
        <h1>Event Partnership</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus,
          tenetur dolorem porro vel mollitia vero, ipsam animi explicabo fugit,
          nobis soluta nulla quidem. Et nemo veniam inventore voluptatum tenetur
          numquam, ea temporibus praesentium. Minima, delectus. Quod fugit est
          delectus maiores sequi, voluptas odio autem ipsa laborum quis numquam
          ad omnis vero iste. Esse odit, excepturi libero illo, molestias rerum
          vero debitis aspernatur, ut ex dolores laboriosam deleniti. Rerum
          distinctio inventore, vel delectus consectetur ut nihil fugiat
          deserunt excepturi odit repudiandae nam ab repellat, natus possimus
          veritatis amet accusamus tenetur quibusdam saepe rem dolorem? Ut
          exercitationem iusto dignissimos reprehenderit expedita aliquid!
        </p>
      </div>
      <div>
        <h1>Initiate Campaign</h1>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae
          perspiciatis aliquid saepe minima reprehenderit maiores dolore magni
          quasi, ab delectus vel accusamus praesentium non ipsum voluptas
          necessitatibus ipsam harum, quibusdam totam voluptatem nobis provident
          hic? Sint facilis quam, corporis animi numquam ab dolores maxime optio
          similique maiores quidem adipisci blanditiis quae quasi perspiciatis
          voluptates aut officia aperiam dignissimos laudantium reprehenderit
          omnis architecto autem nisi. Cum ex exercitationem distinctio libero
          aperiam culpa odit nulla doloribus? Explicabo quos, eaque aperiam
          pariatur vero perferendis ad quas, fugit ipsa odio id odit soluta
          itaque eligendi reiciendis voluptate, magnam vitae mollitia eum ipsam
          velit voluptatum!
        </p>
      </div>
      <div>
        <h1>Project Opportunity</h1>
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Error
          dolores ea veritatis earum ullam blanditiis amet, assumenda harum.
          Repellat possimus et quaerat corrupti, unde provident quae neque velit
          quibusdam, eaque aspernatur eveniet! Delectus hic laudantium eos
          inventore deleniti minima reprehenderit! Ipsum nulla asperiores
          recusandae a explicabo quae. Vero maxime ducimus voluptates aut
          aspernatur iste dolor inventore quo consequatur nam ab, vitae repellat
          quas perferendis praesentium? Cum, debitis? Necessitatibus laboriosam
          nihil et minus. Optio earum vel iure in aliquid dolorum quidem eius
          quod, iste, debitis sit accusantium ex consequuntur aliquam? Odit,
          unde aut ipsum quis id ratione magnam cupiditate possimus voluptas!
        </p>
      </div>
      <div>
        <h1>Engagement Plan</h1>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit.
          Exercitationem minus, quaerat sint rem earum natus animi quo!
          Laboriosam nobis ullam reprehenderit impedit tempora. Illum officia
          earum, debitis quasi perspiciatis non voluptates laudantium quisquam
          fuga dolorem laborum accusamus tempore provident vero consequuntur
          sunt ratione, est pariatur, totam qui quas porro eius quia! Impedit
          iusto enim dolor alias, ratione ducimus pariatur dignissimos aliquid?
          Laudantium adipisci soluta asperiores neque rerum minima eaque
          voluptatum veniam facilis unde. Nostrum ipsam reiciendis aliquid nam,
          laboriosam soluta esse, modi harum nesciunt, beatae facilis
          reprehenderit error sit similique tempore quod cum saepe doloremque
          commodi pariatur minus voluptates! Fugiat.
        </p>
      </div>
      <div>
        <h1>Collaboration Opportunity</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe eum
          delectus porro eos possimus, architecto, quisquam ullam quos fugiat
          sed, sapiente ut provident hic? Exercitationem voluptatem illo
          pariatur alias mollitia, corporis sapiente maiores, nobis incidunt
          culpa ratione, dolor rem! Sed sequi rerum voluptas sapiente corrupti
          delectus dolorum? Accusantium totam sit aliquid aliquam culpa, quia
          quibusdam officia placeat distinctio id facilis, omnis ullam esse
          eligendi molestiae earum neque at aspernatur cumque quod, aperiam
          ipsam. Nihil tenetur autem repellat! Veniam, vitae voluptates ex
          tenetur a unde exercitationem, suscipit deserunt nobis recusandae
          quis! Adipisci, veritatis! Soluta laudantium animi accusantium tempore
          illo, impedit maiores?
        </p>
      </div>
      <a href="https://forms.gle/9FpUDRyPkvqRmknp9" target="_blank" rel="noreferrer"><button className="gl-btn display-5">Contact Us</button></a>
    </motion.div>
  );
};

export default Collaboration;
